import { RfxSubmissionStatusPill } from "./RfxSubmissionStatusPill";

export default RfxSubmissionStatusPill;
